import Icon from '../components/Icon.vue'

Icon.register({
  'venus-mars': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 0H485C474.3 0 469 12.9 476.5 20.5L493.4 37.4 444.7 86.1C422.5 72.1 396.2 64 368 64 334.3 64 303.4 75.6 278.8 94.9 292.8 111.6 303.8 130.9 310.9 152 325.4 137.2 345.6 128 368 128 412.1 128 448 163.9 448 208S412.1 288 368 288C345.7 288 325.4 278.8 310.9 264 303.8 285.1 292.9 304.4 278.8 321.1 303.3 340.5 334.3 352 368 352 447.5 352 512 287.5 512 208 512 179.8 503.9 153.5 489.9 131.3L538.6 82.6 555.5 99.5C557.9 101.9 560.9 103 563.9 103 570.1 103 576 98.2 576 91V12C576 5.4 570.6 0 564 0zM144 64C64.5 64 0 128.5 0 208 0 276.5 47.9 333.9 112 348.4V400H76C69.4 400 64 405.4 64 412V452C64 458.6 69.4 464 76 464H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V464H212C218.6 464 224 458.6 224 452V412C224 405.4 218.6 400 212 400H176V348.4C240.1 333.8 288 276.5 288 208 288 128.5 223.5 64 144 64zM144 288C99.9 288 64 252.1 64 208S99.9 128 144 128 224 163.9 224 208 188.1 288 144 288z'
      }
    ]
  }
})
